import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { LazyImageWrapper } from '../../components/global/LazyImageWrapper';
import { ItemImage } from '../../components/global/ItemImage';

import {
    VERTICAL_OFFSET_MOBILE_IMG,
    HORIZONTAL_OFFSET_MOBILE_IMG,
} from '../../constants/imageConstants';
import { CREATOR_UNKNOWN } from 'dibs-search-product-tile/exports/constants';

import styles from './SharedProductCarouselItem.scss';

const CREATOR_ATTRIBUTED_BY = 'BY';
const CREATOR_ATTRIBUTED_BY_AND_DOCUMENTED = 'BY_AND_DOCUMENTED';

const CREATOR_ATTRIBUTION_LIST = [CREATOR_ATTRIBUTED_BY, CREATOR_ATTRIBUTED_BY_AND_DOCUMENTED];

export const SharedProductCarouselItemComponent = ({ edge, showOverlay, isClient }) => {
    const { node, cmsData } = edge;
    const { localizedPdpUrl, creators } = node;
    const { title, description } = cmsData;

    // Creator Attribution
    const attribution =
        creators && creators.find(el => CREATOR_ATTRIBUTION_LIST.includes(el.attribution));
    const attributionCreatorName = get(attribution, 'creator.displayName');
    const shouldShowCreatorName =
        !!attributionCreatorName && attributionCreatorName !== CREATOR_UNKNOWN;

    return (
        <a className={styles.wrapper} href={localizedPdpUrl}>
            <div className={styles.imageWrapper}>
                <LazyImageWrapper
                    offsetVertical={VERTICAL_OFFSET_MOBILE_IMG}
                    offsetHorizontal={HORIZONTAL_OFFSET_MOBILE_IMG}
                    item={node}
                >
                    <ItemImage item={node} className={styles.image} isClient={isClient} />
                </LazyImageWrapper>
            </div>

            <div className={styles.title}>{title}</div>
            {shouldShowCreatorName && (
                <div className={styles.creator}>
                    <FormattedMessage
                        id="productCarousel.creator.by"
                        defaultMessage="By {attributionCreatorName}"
                        values={{ attributionCreatorName }}
                    />
                </div>
            )}

            {showOverlay && <div className={styles.description}>{description}</div>}
        </a>
    );
};

SharedProductCarouselItemComponent.propTypes = {
    edge: PropTypes.object.isRequired,
    showOverlay: PropTypes.bool,
    isClient: PropTypes.bool.isRequired,
};

export const SharedProductCarouselItem = createFragmentContainer(
    SharedProductCarouselItemComponent,
    {
        edge: graphql`
            fragment SharedProductCarouselItem_edge on CmsItemsEdge {
                cmsData {
                    title
                    description
                }
                node {
                    ...LazyImageWrapper_item
                    ...ItemImage_item
                    localizedPdpUrl
                    creators {
                        attribution
                        creator {
                            displayName
                        }
                    }
                }
            }
        `,
    }
);
